import type { SVGProps } from "react";
export const BoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className="fill-current"
    aria-label="Bone"
    role="img"
    {...props}
  >
    <path
      d="M8.97264 3.17244C9.64523 2.49981 10.7361 2.49982 11.4086 3.17244C11.6973 3.46109 11.8608 3.82705 11.9018 4.20318C12.2781 4.24406 12.6442 4.40804 12.933 4.69683C13.6056 5.36946 13.6057 6.46021 12.933 7.13283C12.3907 7.67518 11.5771 7.77945 10.9301 7.44825C10.8782 7.42173 10.8248 7.41119 10.7846 7.4131C10.7479 7.41486 10.7347 7.42545 10.7299 7.43019L7.44972 10.7104C7.44498 10.7152 7.43439 10.7283 7.43263 10.7651C7.43072 10.8052 7.44126 10.8587 7.46778 10.9106C7.79898 11.5576 7.69471 12.3711 7.15236 12.9135C6.47974 13.5861 5.38899 13.5861 4.71636 12.9135C4.42757 12.6247 4.26359 12.2586 4.22272 11.8823C3.84659 11.8413 3.48062 11.6778 3.19197 11.3891C2.51935 10.7165 2.51934 9.6257 3.19197 8.95311C3.73433 8.41075 4.54788 8.30648 5.19487 8.63769C5.24679 8.66421 5.30024 8.67475 5.34037 8.67284C5.37708 8.67108 5.39024 8.66052 5.39506 8.65575L8.67528 5.37553L8.68505 5.36039C8.68854 5.35191 8.69149 5.33933 8.69237 5.32084C8.69428 5.28071 8.68374 5.22726 8.65722 5.17534C8.32601 4.52835 8.43028 3.7148 8.97264 3.17244Z"
      fill="currentColor"
    />
  </svg>
);
